// ** React Imports
import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useOpenGraphMetaTags from "hooks/useOpenGraphMetaTags";

// ** Config
import configGlobal from "configuration";
import { META_DESCRIPTION_2 } from "helpers/constants";

// #####################################################

const useGalleryMetaTags = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors", "pages"]);

	const { pathname } = useLocation();

	const siteName = useMemo(() => {
		if (pathname === "/galleries/photos") {
			return "images";
		} else if (pathname === "/galleries/videos") {
			return "videos";
		} else {
			return "galleries";
		}
	}, [pathname]);

	// ** Tytuł Strony - Atrybut 'title'
	const title = t(`pages:${siteName}`);

	// ** Meta Description
	const metaDescription = useMemo(() => {
		return `Najnowsze ${title.toLowerCase()}. Płeć: Kobieta, Mężczyzna, Para, Trans. ${META_DESCRIPTION_2}`;
	}, [siteName]);

	// ** Open Graph Meta Tags
	const ogMetaTags = useOpenGraphMetaTags({
		customTitle: title,
		customDescription: metaDescription,
	});

	const canonicalLink = useCallback(() => {
		if (pathname === "/galleries/photos") {
			return (
				<link
					rel="canonical"
					href={`https://${configGlobal.host}/galleries/photos`}
				/>
			);
		} else if (pathname === "/galleries/videos") {
			return (
				<link
					rel="canonical"
					href={`https://${configGlobal.host}/galleries/videos`}
				/>
			);
		}
		return (
			<link
				rel="canonical"
				href={`https://${configGlobal.host}/galleries`}
			/>
		);
	}, [pathname]);

	// #####################################################

	return { title, metaDescription, ogMetaTags, canonicalLink };
};

// #####################################################

export default useGalleryMetaTags;

// #####################################################
